import { Options, Vue } from 'vue-class-component';
import {
  IRoomObjectDTO,
  LightType,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';

@Options({
  name: 'FieldsLight',
  props: {
    roomObject: {
      type: Object as PropType<IRoomObjectDTO>,
      required: true,
    },
  },
})
export default class FieldsLight extends Vue {
  roomObject!: IRoomObjectDTO;

  get typeOptions() {
    return Object.keys(LightType)
      .filter(
        (value) => !isNaN(Number(value)) && Number(value) != LightType.None
      )
      .map((value) => Number(value));
  }

  getOptionName(type: LightType) {
    switch (type) {
      case LightType.Dimmer:
        return this.$t(`AppResource.DimmerLight`);
      case LightType.OnOff:
        return this.$t(`AppResource.OnOffLight`);
      default:
        return ''
    }
  }
}
